import { render, staticRenderFns } from "./DoubleElimination.vue?vue&type=template&id=af17c8aa&scoped=true"
import script from "./DoubleElimination.vue?vue&type=script&lang=js"
export * from "./DoubleElimination.vue?vue&type=script&lang=js"
import style0 from "./DoubleElimination.vue?vue&type=style&index=0&id=af17c8aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af17c8aa",
  null
  
)

export default component.exports